"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificationIcon = exports.CertificationLabel = void 0;
const tslib_1 = require("tslib");
const catalog_icons_1 = require("@tableau/catalog-icons");
const catalog_messages_1 = require("@tableau/catalog-messages");
const CertifiedBaseIcon_1 = require("@tableau/icons/CertifiedBaseIcon");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const LabelPopover_1 = require("../LabelPopover");
const useControlledPopover_1 = require("../shared/useControlledPopover");
function CertificationLabel(props) {
    var _a, _b, _c, _d;
    const popover = (0, useControlledPopover_1.useControlledPopover)({
        testId: props.testId,
        popoverProps: {
            title: certificationLabelTitle(props),
            placement: (_b = (_a = props.controls) === null || _a === void 0 ? void 0 : _a.popoverPlacement) !== null && _b !== void 0 ? _b : 'bottom-start',
        },
        content: LabelPopover_1.LabelPopover,
        controlKind: (_d = (_c = props.controls) === null || _c === void 0 ? void 0 : _c.kind) !== null && _d !== void 0 ? _d : 'icon',
        iconProps: certificationIconProps,
        chipProps: certificationChipProps,
        onClick: props.onClick,
        loading: props.loading,
        props: Object.assign({}, props),
        renderMode: props.renderMode,
    });
    return popover !== null && popover !== void 0 ? popover : react_1.default.createElement(react_1.default.Fragment, null);
}
exports.CertificationLabel = CertificationLabel;
function certificationIconProps() {
    return {
        getContent: (s) => react_1.default.createElement(CertificationIcon, { state: s }),
        style: {
            height: '14px',
            width: '14px',
        },
        buttonType: widgets_1.ButtonType.Icon,
        kind: 'button-props',
    };
}
function CertificationIcon(props) {
    const { state } = props;
    return (react_1.default.createElement("span", null, (state === null || state === void 0 ? void 0 : state.active) || (state === null || state === void 0 ? void 0 : state.hover) || (state === null || state === void 0 ? void 0 : state.selected) || false
        ? react_1.default.createElement(catalog_icons_1.SvgCertifiedIconActive, { "aria-label": catalog_messages_1.Messages.Certification() })
        : react_1.default.createElement(catalog_icons_1.SvgCertifiedIconDefault, { "aria-label": catalog_messages_1.Messages.Certification() })));
}
exports.CertificationIcon = CertificationIcon;
function certificationChipProps() {
    return {
        stickerType: 'green',
        icon: react_1.default.createElement(CertifiedBaseIcon_1.CertifiedBaseIcon, { size: 12, alt: catalog_messages_1.Messages.DataQualityTypeCertified() }),
        kind: 'sticker-props',
    };
}
function certificationLabelTitle(_) {
    return catalog_messages_1.Messages.DataQualityTypeCertified();
}
//# sourceMappingURL=CertificationButton.js.map